import React from 'react';
import { Button, ButtonText } from '@/components/ui/button';

export default function BasicButton({ text, onPress, bg, flex, width, isDisabled }) {
    return (
        <Button size='lg' className={`${flex ? 'flex-' + flex : ''} px-0 ${width ? 'w-[' + width + ']' : 'w-full'} ${bg || 'bg-primary-900'} active:${bg ? 'opacity-90' : 'bg-primary-700'}`} isDisabled={isDisabled} onPress={onPress}>
            <ButtonText className="font-normal text-secondary-50">{text}</ButtonText>
        </Button>
    );
}